import get from 'lodash/get';
import isNumber from 'lodash/isNumber';
import {roundTo} from 'round-to';

import {formatOneLineAddress,getLocationOptions} from './locations';

export const getSessionTypeUrl = sessionType => {
  const protocol = 'https';
  const hostname = window.location.hostname;
  const url = `${protocol}://${hostname}/session-types/${sessionType.id}`;
  return url;
};

export const formatSessionTypeLocation = sessionType => {
  if (sessionType.location_type === 'HOME') return 'Patient Home';
  if (sessionType.location_type === 'OTHER_MOBILE') return 'Other Mobile Session';
  if (sessionType.location_type === 'VIRTUAL') return 'Virtual Session';
  if (sessionType.address_line_1) {
    return formatOneLineAddress({...sessionType});
  }
  return '';
};

export const parseSessionTypeLocationType = sessionType => {
  if (sessionType.location_type === 'PROVIDER_HOME') return 'Provider Home';
  const option = getLocationOptions().find(
    opt => opt.value === sessionType.location_type
  );
  const str = get(option, 'label', '');
  return str;
};

export const describeSessionTypeLocation = sessionType => {
  if (sessionType.location_type === 'HOME') return 'We will come to you in your home.';
  if (sessionType.location_type === 'OTHER_MOBILE') return 'We\'ll come to you at your work, school, local park, or anywhere!';
  if (sessionType.location_type === 'VIRTUAL') return 'Connect via your phone, tablet, or laptop.';
  if (sessionType.location_type === 'PARTNER') return 'Visit us at our partner clinic location.';
  return '';
};

export const getSessionRate = sessionType => {
  const hourlyRate = sessionType?.hourly_rate;
  const duration = sessionType?.duration_minutes;
  if (!isNumber(hourlyRate) || !duration) return '';
  const durationFraction = duration / 60;
  const sessionRate = hourlyRate * durationFraction;
  return roundTo(sessionRate, 2);
};
